import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.f5x_1 = call;
        this.g5x_1 = data.l5l_1;
        this.h5x_1 = data.k5l_1;
        this.i5x_1 = data.n5l_1;
        this.j5x_1 = data.m5l_1;
        this.k5x_1 = data.p5l_1;
      }
      t5i() {
        return this.f5x_1;
      }
      ew() {
        return this.t5i().ew();
      }
      u5i() {
        return this.g5x_1;
      }
      v5i() {
        return this.h5x_1;
      }
      t2o() {
        return this.i5x_1;
      }
      n50() {
        return this.j5x_1;
      }
      n5i() {
        return this.k5x_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
